unit Auth.Service;
interface

uses
  JS;

type

  TSphinxTokenType = (sttAccess, sttId);

  TAuthService = class
  private
    FAccessPayload: TJSObject;
    FIdPayload: TJSObject;
    function DecodePayload(const AToken: string): string;
    function GetAccessPayloadObject: TJSObject;
    function GetIdPayloadObject: TJSObject;
    function GetRefreshToken: string;
    function MaskToken(const AToken: string): string;

  public
    function Authenticated: Boolean;
    function GetAccessToken: string;
    function GetClaimValue(const AName: string; const ATokenType: TSphinxTokenType = sttAccess): string;
    function GetClaimValueInt(const AName: string; const ATokenType: TSphinxTokenType = sttAccess): NativeInt;

    function IsAdministrator: Boolean;
    function IsSuperUser: Boolean;
    function InternalUserId: Integer;
    function UserScope: string;
    function UserFullName: string;
    function Expiration: TDateTime;
    function TimeToLiveInMinutes: Integer;
    function TimeToLiveInSeconds: Integer;

    function IsTokenExpired: Boolean;
    procedure InvalidateTokenCache;

    procedure LogTokenState(const AContext: string);
  end;

function AuthService: TAuthService;

implementation

uses
  System.SysUtils,
  System.DateUtils,
  MainDataModule,
  SMX.Auth.Shared;

var
  _AuthService: TAuthService;

function AuthService: TAuthService;
begin
  if not Assigned(_AuthService) then
  begin
    _AuthService := TAuthService.Create;
  end;
  Result := _AuthService;
end;

{ TAuthService }

function TAuthService.Authenticated: Boolean;
begin
  Result := MainData.SphinxLogin.IsLoggedIn;
end;

function TAuthService.DecodePayload(const AToken: string): string;
begin
  if Trim(AToken) = '' then
    Exit('');
  Result := '';
{$IFDEF PAS2JS}
  asm
    var Token = AToken.split('.');
    if (Token.length = 3) {
    Result = Token[1];
    Result = atob(Result);
     }
  end;
{$ENDIF}
end;

function TAuthService.GetClaimValue(const AName: string; const ATokenType: TSphinxTokenType = sttAccess): string;
var
  Obj: TJSObject;
begin
  Result := '';
  if ATokenType = sttAccess then
    Obj := GetAccessPayloadObject
  else
    Obj := GetIdPayloadObject;

  if (Obj <> nil) and Obj.hasOwnProperty(AName) then
    Result := JS.toString(Obj.Properties[AName]);
end;

function TAuthService.GetClaimValueInt(const AName: string; const ATokenType: TSphinxTokenType): NativeInt;
var
  Obj: TJSObject;
begin
  Result := 0;
  if ATokenType = sttAccess then
    Obj := GetAccessPayloadObject
  else
    Obj := GetIdPayloadObject;

  if (Obj <> nil) and Obj.hasOwnProperty(AName) then
    Result := JS.toInteger(Obj.Properties[AName]);

end;

function TAuthService.GetAccessPayloadObject: TJSObject;
var
  AToken, Payload: string;
begin
  Result := nil;
  if not Assigned(FAccessPayload) then
  begin
    AToken := GetAccessToken;
    if AToken = '' then
      Exit;
    Payload := DecodePayload(AToken);
    if Payload = '' then
      Exit;
    FAccessPayload := TJSObject(TJSJSON.parse(Payload));
  end;

  Result := FAccessPayload;
end;

function TAuthService.GetAccessToken: string;
begin
  Result := '';
  if MainData.SphinxLogin.AuthResult <> nil then
    Result := MainData.SphinxLogin.AuthResult.AccessToken;
end;

function TAuthService.GetIdPayloadObject: TJSObject;
var
  AToken, Payload: string;
begin
  Result := nil;
  if not Assigned(FIdPayload) then
  begin
    if MainData.SphinxLogin.AuthResult = nil then
      Exit;
    AToken := MainData.SphinxLogin.AuthResult.IdToken;
    if AToken = '' then
      Exit;
    Payload := DecodePayload(AToken);
    if Payload = '' then
      Exit;
    FIdPayload := TJSObject(TJSJSON.parse(Payload));
  end;

  Result := FIdPayload;

end;

function TAuthService.UserFullName: string;
begin
  Result := GetClaimValue(CLAIM_FULLNAME);
end;

function TAuthService.InternalUserId: Integer;
var
  lValue: string;
begin
  // Note this is the InternalId of the user
  lValue := GetClaimValue(CLAIM_USER_INTERNAL_ID);
  if lValue <> '' then
    Result := JS.toInteger(lValue)
  else
    Result := 0;
end;

function TAuthService.IsAdministrator: Boolean;
var
  lLevel: string;
begin
  lLevel := GetClaimValue(CLAIM_SCOPE);
  Result := (lLevel = SCOPE_ADMIN) or (lLevel = SCOPE_SUPERUSER);
end;

function TAuthService.IsSuperUser: Boolean;
var
  lLevel: string;
begin
  lLevel := GetClaimValue(CLAIM_SCOPE);
  Result := (lLevel = SCOPE_SUPERUSER);
end;

function TAuthService.TimeToLiveInMinutes: Integer;
var
  ExpDate: TDateTime;
begin
  Result := 0;
  ExpDate := Expiration;
  if ExpDate < Now then
    Exit;
  Result := MinutesBetween(Now, ExpDate);
end;

function TAuthService.TimeToLiveInSeconds: Integer;
var
  ExpDate: TDateTime;
begin
  Result := 0;
  ExpDate := Expiration;
  if ExpDate < Now then
    Exit;
  Result := SecondsBetween(Now, ExpDate);
end;

function TAuthService.Expiration: TDateTime;
var
  ExpirationDate: TJSDate;
  Epoch: NativeInt;
begin
  if not Authenticated then
    Exit(Now);

  Epoch := GetClaimValueInt('exp');
  if Epoch = 0 then
    Exit(Now);

  ExpirationDate := TJSDate.New(Epoch * 1000);

  Result := EncodeDate(ExpirationDate.FullYear, ExpirationDate.Month + 1, ExpirationDate.Date) +
    EncodeTime(ExpirationDate.Hours, ExpirationDate.Minutes, ExpirationDate.Seconds, 0);

end;

function TAuthService.UserScope: string;
begin
  Result := GetClaimValue(CLAIM_SCOPE);
end;

function TAuthService.IsTokenExpired: Boolean;
begin
  if not Authenticated or (MainData.SphinxLogin.AuthResult = nil) then
    Exit(True);
  Result := MainData.SphinxLogin.AuthResult.IsExpired;
end;

procedure TAuthService.InvalidateTokenCache;
begin
  LogTokenState('InvalidateTokenCache');
  FAccessPayload := nil;
  FIdPayload := nil;
end;

function TAuthService.GetRefreshToken: string;
begin
  Result := '';
  if MainData.SphinxLogin.AuthResult <> nil then
    Result := MainData.SphinxLogin.AuthResult.RefreshToken;
end;

function TAuthService.MaskToken(const AToken: string): string;
begin
  if Trim(AToken) = '' then
    Exit('(none)');
  if Length(AToken) <= 16 then
    Exit('(short)');
  Result := Copy(AToken, 1, 12) + '...' + Copy(AToken, Length(AToken) - 3, 4);
end;

procedure TAuthService.LogTokenState(const AContext: string);
var
  lMsg: string;
begin
{$IFDEF DEBUG}
  if MainData.SphinxLogin.AuthResult = nil then
  begin
{$IFDEF PAS2JS}
    asm
      console.log('[Auth]', AContext, '| no auth result');
    end;
{$ENDIF}
    Exit;
  end;

  lMsg := Format(
    '%s | loggedIn=%s expired=%s ttl=%ds access=%s refresh=%s',
    [AContext,
     BoolToStr(Authenticated, True),
     BoolToStr(IsTokenExpired, True),
     TimeToLiveInSeconds,
     MaskToken(GetAccessToken),
     MaskToken(GetRefreshToken)]);
{$IFDEF PAS2JS}
  asm
    console.log('[Auth]', lMsg);
  end;
{$ENDIF}
{$ENDIF}
end;

end.
